"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const portal_1 = __importDefault(require("@kawaui/portal"));
const react_1 = require("react");
const react_popper_1 = require("react-popper");
const react_transition_group_1 = require("react-transition-group");
const icon_1 = require("./components/icon");
const hooks_1 = require("./hooks");
const styled_1 = require("./styled");
const getDuration = (duration) => {
    switch (duration) {
        case 'min':
            return 3000;
        case 'med':
            return 5000;
        case 'max':
            return 10000;
        default:
            return undefined;
    }
};
const Notification = (0, react_1.forwardRef)((props, forwardedRef) => {
    const { children, open, variant = 'error', container, onClose, duration = 'fixed', customIcon: icon, disableIcon, text, portalContainer } = props, otherProps = __rest(props, ["children", "open", "variant", "container", "onClose", "duration", "customIcon", "disableIcon", "text", "portalContainer"]);
    const reference = (0, hooks_1.useReference)(container);
    const [popper, setPopper] = (0, react_1.useState)(null);
    const { styles, attributes } = (0, react_popper_1.usePopper)(reference, popper);
    const onEntered = () => {
        if (duration !== 'fixed' && typeof onClose === 'function') {
            setTimeout(() => onClose(), getDuration(duration));
        }
    };
    return ((0, jsx_runtime_1.jsx)(portal_1.default, { container: portalContainer, children: (0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { appear: true, in: open, timeout: styled_1.ANIMATION_DURATION, mountOnEnter: true, unmountOnExit: true, onEntered, children: (0, jsx_runtime_1.jsx)(styled_1.NotificationWrapper, Object.assign({ ref: setPopper, style: styles.popper }, attributes.popper, { children: (0, jsx_runtime_1.jsxs)(styled_1.StyledNotification, Object.assign({ ref: forwardedRef, variant: variant }, otherProps, { children: [!disableIcon && (0, jsx_runtime_1.jsx)(icon_1.Icon, { variant: variant, icon: icon }), (0, jsx_runtime_1.jsx)(styled_1.StyledText, { children: children })] })) })) }) }));
});
Notification.displayName = 'Notification';
exports.default = Notification;
